import React from 'react';
import './HeaderCard.css';
import { Card } from '../Card/Card';
import { Stack } from '../Stack/Stack';

interface Props {
  title: React.ReactNode;
  titleAdornment?: React.ReactNode;
  subTitle: React.ReactNode;
  actions?: React.ReactNode;
}

export function HeaderCard({ title, subTitle, actions, titleAdornment }: Props): JSX.Element {
  return (
    <Card actions={actions}>
      <Stack size="xxs">
        <Stack line size="xxs">
          <span className="header-card__title">{title}</span>
          {titleAdornment && <span>{titleAdornment}</span>}
        </Stack>
        {subTitle && <div className="header-card__subtitle">{subTitle}</div>}
      </Stack>
    </Card>
  );
}
